import { useContext } from 'react';

import { ApiContext } from '_lib/api/apiContext';
import { ourQueryClient } from '_lib/api/QueryProvider';

export const useZipCodeData = (companyId: string, options?: { enabled?: boolean }) => {
  const api = useContext(ApiContext);
  const enabled = options?.enabled ?? true;

  const zonesQuery = api.serviceTitan(companyId).zones.useUnpagedList({}, { enabled });
  const businessUnitsQuery = api.serviceTitan(companyId).businessUnits.useUnpagedList({}, { enabled });

  const companyQueryKey = api.companies.getByIdQueryKey({ id: companyId });

  return {
    zones: zonesQuery.data,
    businessUnits: businessUnitsQuery.data,
    isLoading: zonesQuery.isLoading || businessUnitsQuery.isLoading,
    isFetching: zonesQuery.isFetching || businessUnitsQuery.isFetching,
    error: zonesQuery.error || businessUnitsQuery.error,
    zonesError: zonesQuery.error,
    businessUnitsError: businessUnitsQuery.error,
    refetch: () => {
      zonesQuery.refetch();
      businessUnitsQuery.refetch();
      ourQueryClient.invalidateQueries({ queryKey: companyQueryKey });
    }
  };
};

export type ZipCodeData = ReturnType<typeof useZipCodeData>;
